import {
  $adminsTableFilters,
  $adminsTablePage,
  $adminsTablePageSize,
  $adminsTableSearch,
  $adminsTableSort,
  type AdminsSortState,
} from '@/entities/admins'
import { type GetApiAdminsQueryParams } from '@/shared/api'
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from '@/shared/lib/query'
import { createStore, sample } from 'effector'
import { createGate } from 'effector-react'

// Gate
export const AdminsListPageGate = createGate()

// Last state

// Filters
export const $adminsListPageLatestFilters =
  createStore<GetApiAdminsQueryParams>({})
sample({
  source: $adminsTableFilters,
  clock: AdminsListPageGate.close,
  target: $adminsListPageLatestFilters,
})
// Sort
export const $adminsListPageLatestSort = createStore<AdminsSortState>({
  field: null,
  order: null,
})
sample({
  source: $adminsTableSort,
  clock: AdminsListPageGate.close,
  target: $adminsListPageLatestSort,
})
// Page
export const $adminsListPageLatestPage = createStore<number>(DEFAULT_PAGE)
sample({
  source: $adminsTablePage,
  clock: AdminsListPageGate.close,
  target: $adminsListPageLatestPage,
})
// Page size
export const $adminsListPageLatestPageSize =
  createStore<number>(DEFAULT_PAGE_SIZE)
sample({
  clock: AdminsListPageGate.close,
  source: $adminsTablePageSize,
  target: $adminsListPageLatestPageSize,
})
// Search
export const $adminsListPageLatestSearch = createStore<string>('')
sample({
  clock: AdminsListPageGate.close,
  source: $adminsTableSearch,
  fn: (search) => search || '',
  target: $adminsListPageLatestSearch,
})
